module.exports = __webpack_public_path__ + "static/img/metal41.a98d6b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal41.jpg
// module id = eQB1
// module chunks = 0